import Axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

export default class ApiClient {

    constructor() {
        this.baseUrl = process.env.VUE_APP_API_BASE_URL;
    }

    create() {
        return Axios.create({
            baseURL: this.baseUrl
        });
    }

    createAuthed() {
        var request = Axios.create({
            baseURL: this.baseUrl,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });

        // request.interceptors.response.use(response => response, error => {
        //     if (error.response.status === 401) {

        //     }
        // });

        return request;
    }

}
